import {
  DataModelBuilder, SerializationContext, SerializedData, isSameData,
} from '../../models/dto/dto.js';
import { Price } from '../../models/serializable/price.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class DynamicPricingSettingsComponent extends Component {
  static readonly TYPE_ID: string = '929c51eb09c247c5860597e2c27d8152';

  constructor(
    public readonly maxModifierPercentage: number | null,
    public readonly maxModifierPrice: Price | null,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return DynamicPricingSettingsComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DynamicPricingSettingsComponent {
    return new DynamicPricingSettingsComponent(
        MapUtils.getOrNull<number>(map, 'maxModifierPercentage'),
        Price.decodeOrNull(MapUtils.getOrNull<string>(map, 'maxModifierPrice')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'maxModifierPercentage': this.maxModifierPercentage,
      'maxModifierPrice': this.maxModifierPrice?.encode() ?? null,
    };
  }

  clone(): this {
    return new DynamicPricingSettingsComponent(
        this.maxModifierPercentage,
        this.maxModifierPrice?.clone() ?? null,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.maxModifierPercentage === this.maxModifierPercentage &&
      isSameData(other.maxModifierPrice, this.maxModifierPrice);
  }
}

export class DynamicPricingSettingsComponentBuilder extends DataModelBuilder<DynamicPricingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): DynamicPricingSettingsComponent {
    return DynamicPricingSettingsComponent.fromMap(context, map);
  }
}
